import { Link, Stack } from "@mui/material";
import { Agent } from "@src/interface";
import { Text } from "@src/lib/ui-react";
import { Card } from "antd";
import { useGetAgentInfo } from "./useGetAgentInfo";

interface AgentReferralProps {
  agent: Agent;
}

export function AgentReferral(props: AgentReferralProps) {
  const { agent } = props;

  const { data: referrer } = useGetAgentInfo(agent.referralCodeUsed?.referrer);

  return (
    <Card title="Referral">
      <Stack>
        <Text>Referral Code: {agent.referralCode}</Text>
      </Stack>
      {agent.referralCodeUsed && referrer ? (
        <Stack direction="row" spacing={0.5}>
          <Text>Referrer: </Text>
          <Link href={`/calendar?userId=${referrer.userId}&drawer=Agent`}>{referrer.name}</Link>
        </Stack>
      ) : undefined}
    </Card>
  );
}
